import { xmlDecl, el } from './index.js';

interface ManifestEntry {
  fullPath: string;
  mediaType: string;
}

export function generateManifestXml(entries: ManifestEntry[]): string {
  const items = entries
    .map(
      (e) =>
        '\n' +
        el('manifest:file-entry', {
          'manifest:full-path': e.fullPath,
          'manifest:media-type': e.mediaType,
        }),
    )
    .join('');

  return (
    xmlDecl() +
    '\n' +
    el(
      'manifest:manifest',
      { 'xmlns:manifest': 'urn:oasis:names:tc:opendocument:xmlns:manifest:1.0' },
      items + '\n',
    )
  );
}

export function buildManifestEntries(sectionCount: number, binData: { name: string; format: string }[]): ManifestEntry[] {
  const entries: ManifestEntry[] = [
    { fullPath: '/', mediaType: 'application/hwp+zip' },
    { fullPath: 'version.xml', mediaType: 'application/xml' },
    { fullPath: 'Contents/content.hpf', mediaType: 'application/xml' },
    { fullPath: 'Contents/header.xml', mediaType: 'application/xml' },
    { fullPath: 'settings.xml', mediaType: 'application/xml' },
  ];

  for (let i = 0; i < sectionCount; i++) {
    entries.push({
      fullPath: `Contents/section${i}.xml`,
      mediaType: 'application/xml',
    });
  }

  for (const bin of binData) {
    const mimeMap: Record<string, string> = {
      jpg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      bmp: 'image/bmp',
      tiff: 'image/tiff',
      wmf: 'image/x-wmf',
      emf: 'image/x-emf',
    };
    entries.push({
      fullPath: `BinData/${bin.name}`,
      mediaType: mimeMap[bin.format] || 'application/octet-stream',
    });
  }

  return entries;
}
